import AuthToken from "../auth-token.tsx";
import { MDXSection } from "./snippets";
import { StatusDiagram } from "./status-diagram";

You can use the [OpenAI Python client](https://pypi.org/project/openai/) to run **{props.runnableName}** on Replicate.

```python
import os

from openai import OpenAI

client = OpenAI(
    api_key=os.environ["REPLICATE_API_TOKEN"],
    base_url="https://openai-proxy.replicate.com/v1",
)

completion = client.chat.completions.create(
    model="{{ runnableName }}",
    messages=[
        { "role": "system", "content": "You are a helpful assistant." },
        { "role": "user", "content": "What is the capital of the moon?" },
    ],
)
print(completion.choices[0].message.content)
```

<ol className="not-prose">
  <li>Set `base_url` to `https://openai-proxy.replicate.com/v1`</li>
  <li>Set `api_key` to your `REPLICATE_API_TOKEN` environment variable</li>
  <li>Set `model` to <code>{ props.runnableName }</code></li>
</ol>

You can learn about pricing for this model on the <a href={route("model_detail", { name: props.version._extras.model.name, username: props.version._extras.model.owner })}>model page</a>.
